export default __webpack_public_path__ + "static/NotoSans-Italic.subset-53569e6113bbdbe20dd67d3392d4ff93.woff2";